export default __webpack_public_path__ + "static/media/prog.a8a7cc64.svg";